import { createContext } from '@lit/context';
import { ContentDetailsClient } from '../clients/content-details-client';

export const contentDetailsClientContext = createContext<ContentDetailsClient>(
  Symbol('content-details-client-context')
);
